import { cn } from '../ui/utils';

const TONES = {
  orange: 'from-orange-500 to-amber-600',
  purple: 'from-purple-500 to-fuchsia-600',
  blue: 'from-blue-500 to-indigo-600',
  emerald: 'from-emerald-500 to-teal-600',
};

export function StatPill({ icon: Icon, label, value, tone = 'blue', className }) {
  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded-2xl border border-slate-200/60 bg-white px-4 py-2.5 shadow-sm',
        className
      )}
    >
      <div
        className={cn(
          'flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br text-white shadow-sm',
          TONES[tone] || TONES.blue
        )}
      >
        {Icon && <Icon className="h-4 w-4" />}
      </div>
      <div>
        <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">
          {label}
        </p>
        <p className="text-base font-bold tabular-nums leading-tight text-slate-900">{value}</p>
      </div>
    </div>
  );
}

export default StatPill;
